// ---------------------------------------------
// Header Banner - DeSight Shopify Theme
// ---------------------------------------------

export class HeaderBanner {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {}

  static initAll() {
    document.querySelectorAll('.header-banner').forEach((section) => {
      new HeaderBanner(section);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  HeaderBanner.initAll();
});

document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.header-banner');
  if (section) {
    new HeaderBanner(section);
  }
});
